import type { NavbarDropdownType } from '~/components/navbar/dropdown';
import { assert } from '~~/src/layers/toolkit/toolkit';

type NavbarDropdownState =
  | { open: true; type: NavbarDropdownType }
  | { open: false; type: null };

export function useNavbarDropdown(transitionDuration: number) {
  const state = reactive<NavbarDropdownState>({ open: false, type: null });

  function toggle(value: true, type: NavbarDropdownType): void;
  function toggle(value: false): void;
  function toggle(value: boolean, type?: NavbarDropdownType) {
    if (value) {
      assert(
        type !== undefined,
        'NavbarDropdown type must be provided when opening',
      );
      open(state, type);
    } else {
      close(state, transitionDuration);
    }
  }

  return {
    open: computed(() => state.open),
    type: computed(() => state.type),
    toggle,
  };
}

let timeoutClose: ReturnType<typeof setTimeout> | null = null;
function open(state: NavbarDropdownState, type: NavbarDropdownType) {
  if (timeoutClose) {
    clearTimeout(timeoutClose);
    timeoutClose = null;
  }
  state.open = true;
  state.type = type;
}

function close(state: NavbarDropdownState, transitionDuration: number) {
  state.open = false;
  if (timeoutClose) {
    clearTimeout(timeoutClose);
    timeoutClose = null;
  }
  timeoutClose = setTimeout(() => {
    state.type = null;
  }, transitionDuration);
}
